// ABOUTME: First step in external channel creation - allows user to select channel type
// ABOUTME: The warehouse environment connects mailboxes (Outlook), relations connect data channels

import React from 'react';
import { useSelector } from 'react-redux';
import ProgressionTab from '../../../../theme/ProgressionBuilder/ProgressionTab';
import SelectGroup from '../../../../theme/Select/SelectGroup';
import { ENV_TYPES } from '../../../Sidebar';
import PublicIcon from '@mui/icons-material/Public';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { useGetZonosAvailabilityQuery } from '../../../../../newapi/externalchannel/externalChannelSlice';
import { ReactComponent as PredikoLogo } from '../../../../../styles/svg/prediko.svg';
import { ReactComponent as ReturnlessLogo } from '../../../../../styles/svg/returnless.svg';
import { ReactComponent as OutlookLogo } from '../../../../../styles/svg/outlook.svg';
import { ReactComponent as AmpereLogo } from '../../../../../styles/svg/ampere.svg';

const Content = (props) => {
    const selectedEnvironmentType = useSelector((state) => state.settings.environment.selectedEnvironmentType);
    const isRelation = selectedEnvironmentType === ENV_TYPES[200];

    // Zonos references only go on PostNL labels, so the type is offered when the fulfilment
    // has an active PostNL shipper.
    const { data: zonosAvailability } = useGetZonosAvailabilityQuery(undefined, { skip: !isRelation });

    // Outlook and SMTP/IMAP are fulfilment mailboxes used to mail shipper claims and Ampere
    // reports parcels ready for collection per warehouse, so they belong to the warehouse
    // environment; the data channels belong to a relation.
    const columns = isRelation ? [
        { title: "Prediko", logo: <PredikoLogo style={{width:20, height:20}} />, key: "prediko" },
        { title: "Returnless", logo: <ReturnlessLogo style={{width:20, height:20}} />, key: "returnless" },
        ...(zonosAvailability?.available && !zonosAvailability?.connected ? [{ title: "Zonos", logo: <PublicIcon sx={{width:20, height:20}} />, key: "zonos" }] : [])
    ] : [
        { title: "Outlook", logo: <OutlookLogo style={{width:20, height:20}} />, key: "outlook" },
        { title: "SMTP/IMAP", logo: <MailOutlineIcon sx={{width:20, height:20}} />, key: "smtpimap" },
        { title: "Ampère", logo: <AmpereLogo style={{width:20, height:20}} />, key: "ampere" }
    ]

    const handleOptionSelect = (option) => {
        props.handleDataUpdate({
            channel_type: columns[option].key,
            state: 'active'
        });
        props.handleNext("tabBasicInfo");
    };

    return (
        <SelectGroup
            selected={-1}
            setSelected={handleOptionSelect}
            options={columns}
            image={true}
            sx={{
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)",
                gap: "16px",
                gridAutoRows: "auto",
                "@media screen and (max-width: 47.9375em)" : {
                    gridTemplateColumns: "repeat(2, 1fr)",
                },
                option: {
                    flexDirection:"row",
                    alignItems:"center",
                    gap:2,
                    width:1,
                }
            }}
        />
    );
};

const ChooseChannelType = (props) => {
    return (
        <ProgressionTab
            tabId="tabChooseType"
            step={1}
            maxSteps={3}
            sx={{
                body: {
                    maxHeight:550,
                }
            }}
        >
            <Content/>
        </ProgressionTab>
    )
}

export default ChooseChannelType;
